export default __webpack_public_path__ + "static/tooltip-truncation-dont-light-af2f5f2b00325ce002dc5fcbbf111906434a6b2b777d23ad6e4051ff1ed77b9b.png";